import type { FaireProductEntity } from "../../entity_types/product";

export const p_ajhg44p233: FaireProductEntity = {
  token: "p_ajhg44p233",
  type: "product",
  name: "Nourish Hydrating Dog Conditioner",
  brandToken: "b_bf7zwxbsts",
  brandName: "Dandylion",
  imageUrl: "https://cdn.faire.com/fastly/21738060e5cf63016668e196939cb53365a6c1df90bb7ccb61a739ca809414f5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3223455b2664362b29f9b01fe351ab759befe4f4e704ac5ca034da5439f57831.jpeg",
    "https://cdn.faire.com/fastly/811c17d7919894fce7515fa983fa8352189bf67c8f78fb5c16301ac8ca3164a5.jpeg",
    "https://cdn.faire.com/fastly/df0a44d99a9361ce418ae5056f4fb69934069a628473a00d9ed9b36bd4703751.png"
  ],
  priceDollars: 12.5,
  description: "The bath step that makes all the difference.\n\nWhy we love it: A lightweight conditioner that softens your dog's coat and hydrates skin to soothe irritation.\n\nVet-Dermatologist Approved | Fragrance-Free | pH-Balanced for Dogs | Vegan | Cruelty-Free\n",
  tags: [],
  msrpDollars: 25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T16:24:38.183Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
